import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { createMiddleware as abtestingMiddleware, getExperiments } from '@pegasus/abtesting';
import { tracker } from '@browsing/tracking';

import rootReducer from './rootReducer';
import { RootState } from './types';

export default function configureStore(initialState?: RootState) {
    const abtesting = abtestingMiddleware({
        endpoint: '/mylounge-api/abtesting',
        initialExperiments: getExperiments(initialState) as any, // TODO: fix typing in the abtesting lib
        onExperimentLoad: tracker.trackExperimentOnLoad,
    });

    const middleware = [thunk, abtesting];

    // https://github.com/zalmoxisus/redux-devtools-extension#12-advanced-store-setup
    let composeEhancers = compose;
    if (__DEV__ && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
        composeEhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ as any;
    }

    const enhancer = composeEhancers(applyMiddleware(...middleware));
    const store = createStore(rootReducer, initialState, enhancer);

    if (module.hot) {
        module.hot.accept('./rootReducer', () => {
            // eslint-disable-next-line global-require
            const nextRootReducer = require('./rootReducer').default;
            store.replaceReducer(nextRootReducer);
        });
    }

    return store;
}
